import type { SearchMode } from '@/types/api';
import {
  TranslationPillGroup,
  TranslationPill,
} from '@/components/ui/TranslationPillGroup';

type Option = { value: SearchMode; label: string; hint: string };

const OPTIONS: Option[] = [
  { value: 'hybrid', label: 'Hybrid', hint: 'Recommended — combines keyword and semantic ranking.' },
  { value: 'keyword', label: 'Keyword', hint: 'Exact word matches with stemming.' },
  { value: 'semantic', label: 'Semantic', hint: 'Vector similarity, finds related ideas.' },
];

type Props = {
  value: SearchMode;
  onChange: (next: SearchMode) => void;
};

export function SearchModeToggle({ value, onChange }: Props) {
  return (
    <TranslationPillGroup ariaLabel="Search mode">
      {OPTIONS.map((opt) => (
        <TranslationPill
          key={opt.value}
          active={opt.value === value}
          title={opt.hint}
          onClick={() => onChange(opt.value)}
        >
          {opt.label}
        </TranslationPill>
      ))}
    </TranslationPillGroup>
  );
}